export const ENV_NAME = 'preproduction'
export const HOST_NAME = 'ops.preproduction.mymove.be'
export const API_URL = 'https://preproduction.mymove.be/ops-api'
